import { useRef } from 'react'

import { useCommentService } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/services/useCommentService'
import { useGotoService } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/services/useGotoService'
import { ChartTriggersService } from 'common/builder/components/chart/FlowChart/adapters/generic/triggers/service'
import { useChartTriggersService } from 'common/builder/components/chart/FlowChart/hooks/useChartTriggersService'
import { FlowChartServiceInterface } from 'common/builder/components/chart/FlowChart/lib/services/FlowChartService'

export const useFlowChartServices = (builderId: string, flowId?: string) => {
  const gotoService = useGotoService(builderId)

  const commentService = useCommentService(flowId)
  const triggersService = useChartTriggersService(ChartTriggersService, builderId)

  const services = useRef<FlowChartServiceInterface | null>(null)

  if (!services.current) {
    services.current = {
      gotoService,
      triggersService,
      commentService,
    }
  }

  return services.current
}
